import { ChildUser } from "@joonapp/web-shared"

import { PREFERENCE_KEY } from "../../../constants"
import { useUpdatePreferenceMutation } from "../../../networking/families/mutations"
import { useFamilyQuery } from "../../../networking/queries"
import { getUserFromFamily } from "../../../util/util"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"

export const useManageGameplay = () => {
  const { selectedUserId } = useFamilyUserSelectStore()
  const { data: family } = useFamilyQuery()
  const child = getUserFromFamily(family!, selectedUserId || 0) as ChildUser

  const updatePreferenceMutation = useUpdatePreferenceMutation()

  const updatePreference = async (
    key: (typeof PREFERENCE_KEY)[keyof typeof PREFERENCE_KEY],
    value: any,
    onSuccess?: () => void
  ) => {
    return updatePreferenceMutation.mutate(
      { childId: child.id, key, value },
      { onSuccess }
    )
  }

  const hasAnyRoutineTimeLimits =
    child?.preferences?.morning_limit ||
    child?.preferences?.afternoon_limit ||
    child?.preferences?.night_limit

  return {
    child,
    hasAnyRoutineTimeLimits,
    updatePreference,
  }
}
